import { en } from '../locales/en';
import { es } from '../locales/es';
import { pt } from '../locales/pt';

export const translations = {
  en,
  es,
  pt,
};
